
interface CreditsDisplayProps {
  credits: number;
}

export function CreditsDisplay({ credits }: CreditsDisplayProps) {
  return (
    <div className="flex justify-between items-center bg-muted/50 p-4 rounded-lg mb-4">
      <span className="font-medium">Διαθέσιμα Credits:</span>
      <span className="font-bold text-primary">{credits} Credits</span>
    </div>
  );
}
